import moment from 'moment';

const DATE_TYPE_FORMATTERS: {
  [key in IDateType]: string;
} = {
  Year: 'YYYY',
  Month: 'YYYY-MM',
  Week: 'YYYY-MM-DD',
  Day: 'YYYY-MM-DD',
};
const getDateText = (
  dateType: IDateType,
  date?: string | moment.Moment,
  placeholder = '-',
): string => {
  const m: moment.Moment | null = date ? moment(date) : null;
  let formatter = '';
  if (!m?.isValid()) return placeholder || '';
  formatter = DATE_TYPE_FORMATTERS[dateType] || DATE_TYPE_FORMATTERS.Day;
  return m.format(formatter);
};

export { getDateText };
